import React, { FC } from 'react';
import MessageInput from '~ComponentsImproved/MessageInput';
import Modal from '~ComponentsImproved/Modal';
import { useTableApi } from '~Components/TableUniverse';
import { useI18n } from '~Hooks';

interface Props {
  isShowing: boolean;
  onClose: () => void;
  selectedCheque: string | null;
}

/** Purpose: Renaming a cheque */
const RenameCheque: FC<Props> = ({ isShowing, onClose, selectedCheque }) => {
  const { i18n } = useI18n();
  const tableApi = useTableApi();

  const isHandy = window.innerWidth <= 600;

  const handleRename = (newName: string) => {
    if (selectedCheque) {
      tableApi.setChequeName(selectedCheque, newName);
      tableApi.log.setChequeName(selectedCheque, newName);
    }
  };

  return (
    <Modal isShowing={isShowing} hide={onClose} position="flex-start">
      <MessageInput
        type="text"
        autoFocus
        placeHolder={i18n('TM.Rename.Placeholder')}
        width={isHandy ? '280px' : '496px'}
        onSubmit={(value) => {
          handleRename(value);
          onClose();
        }}
      />
    </Modal>
  );
};

export default RenameCheque;
